module.exports = __webpack_public_path__ + "img/2.3c07daa6.webp";